import React from "react";

type UploadInstructionStepOneProps = {};

const UploadInstructionStepOne: React.FC<
  UploadInstructionStepOneProps
> = () => {
  return (
    <div>
      <svg
        width="96"
        height="97"
        viewBox="0 0 96 97"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="0.5"
          y="1.17969"
          width="95"
          height="95.32"
          rx="9.5"
          fill="white"
        />
        <rect
          x="0.5"
          y="1.17969"
          width="95"
          height="95.32"
          rx="9.5"
          stroke="#282B33"
        />
        <circle
          cx="70.076"
          cy="25.7362"
          r="8.06226"
          fill="white"
          stroke="black"
          strokeWidth="1.02754"
        />
        <path
          d="M80.2746 61.0599V53.8671V48.7324C80.2746 48.363 80.806 48.3062 80.8841 48.6672L82.2228 54.8539C82.2235 54.8571 82.2236 54.8577 82.2244 54.8609C82.2505 54.9616 83.1805 58.4342 86.9854 56.5317C89.1949 55.4269 88.3603 52.4489 88.2785 52.1762C88.2741 52.1614 88.2732 52.161 88.2707 52.1458C88.1899 51.6604 85.2035 34.3437 70.5129 34.3438C55.6959 34.3438 52.7854 51.9598 52.7537 52.1545C52.7527 52.1606 52.7529 52.1582 52.7517 52.1642C52.7126 52.3489 52.0498 55.6561 54.4264 56.5317C57.7978 57.7738 58.7373 55.0598 58.7986 54.8692C58.8011 54.8617 58.8028 54.8548 58.8044 54.8471L60.1417 48.6672C60.2198 48.3061 60.7513 48.363 60.7513 48.7324V53.8671V61.0599M80.2746 61.0599V75.7004C80.2746 75.7046 80.2746 75.7072 80.2743 75.7114C80.267 75.8448 80.0648 78.7954 76.5614 78.7954C73.0698 78.7954 72.8393 75.8648 72.8297 75.7129C72.8294 75.708 72.8293 75.7043 72.8293 75.6994V61.0599M80.2746 61.0599H72.8293M60.7513 61.0599V75.6949C60.7513 75.7028 60.7515 75.7099 60.7522 75.7178C60.7718 75.9182 61.1107 78.7954 64.4643 78.7954C67.8605 78.7954 68.0602 75.8448 68.0675 75.7114C68.0677 75.7072 68.0677 75.7046 68.0677 75.7004V61.0599M60.7513 61.0599H68.0677M68.0677 61.0599H72.8293"
          stroke="black"
          strokeWidth="1.02754"
        />
        <path
          d="M48.0292 74.6762V62.1655C48.0292 61.9584 47.829 61.8102 47.6308 61.8707L46.9846 62.0681C46.8546 62.1079 46.7659 62.2282 46.7664 62.3642L46.8155 74.6774C46.8162 74.8472 46.954 74.9844 47.1238 74.9844H47.7209C47.8912 74.9844 48.0292 74.8464 48.0292 74.6762Z"
          stroke="black"
          strokeWidth="0.822034"
        />
        <path
          d="M40.0246 70.2927V58.0392C40.0246 57.8345 39.8288 57.6866 39.6319 57.7427L38.9846 57.9271C38.8521 57.9648 38.7607 58.0858 38.7607 58.2236V70.2927C38.7607 70.4629 38.8988 70.6009 39.069 70.6009H39.7164C39.8866 70.6009 40.0246 70.4629 40.0246 70.2927Z"
          stroke="black"
          strokeWidth="0.822034"
        />
        <path
          d="M7.78455 63.4092L39.721 57.6481C39.7831 57.6369 39.8472 57.645 39.9045 57.6714L48.0126 61.4001C48.2837 61.5247 48.2372 61.9233 47.9448 61.9823L16.3364 68.361V80.621C16.3364 80.7912 16.1984 80.9292 16.0281 80.9292H15.3933C15.2231 80.9292 15.085 80.7912 15.085 80.621V68.6136L7.67567 63.9738C7.43688 63.8243 7.50728 63.4592 7.78455 63.4092Z"
          fill="white"
        />
        <path
          d="M15.085 68.6136L7.67567 63.9738C7.43688 63.8243 7.50728 63.4592 7.78455 63.4092L39.721 57.6481C39.7831 57.6369 39.8472 57.645 39.9045 57.6714L48.0126 61.4001C48.2837 61.5247 48.2372 61.9233 47.9448 61.9823L16.3364 68.361M15.085 68.6136V80.621C15.085 80.7912 15.2231 80.9292 15.3933 80.9292H16.0281C16.1984 80.9292 16.3364 80.7912 16.3364 80.621V68.361M15.085 68.6136L16.3364 68.361"
          stroke="black"
          strokeWidth="0.822034"
        />
        <path
          d="M7.58496 76.6586V64.0293C7.58496 63.9891 7.62897 63.9644 7.66328 63.9854L8.7013 64.6196C8.79294 64.6756 8.84884 64.7752 8.84884 64.8826V76.6586C8.84884 76.8288 8.71082 76.9668 8.54058 76.9668H7.89322C7.72297 76.9668 7.58496 76.8288 7.58496 76.6586Z"
          stroke="black"
          strokeWidth="0.822034"
        />
        <rect
          x="-0.306159"
          y="-0.230708"
          width="7.73157"
          height="12.7922"
          rx="1.24174"
          transform="matrix(0.970296 -0.241922 0.0348995 0.999391 24.7587 52.3301)"
          fill="white"
          stroke="black"
          strokeWidth="0.609154"
        />
        <path
          d="M27.8057 63.3698L29.6331 62.9434"
          stroke="black"
          strokeWidth="0.487323"
          strokeLinecap="round"
        />
        <path
          d="M26.8074 52.2222L26.5869 51.9429L29.6327 51.1875V51.4722C29.6327 51.6411 29.517 51.788 29.3528 51.8275L27.1799 52.351C27.0412 52.3844 26.8958 52.3341 26.8074 52.2222Z"
          fill="#D9D9D9"
        />
        <path
          d="M30.4434 55.6191L29.728 55.7842L29.3574 55.3244C29.3375 55.2998 29.3112 55.2819 29.2807 55.2724C29.2502 55.2629 29.2164 55.262 29.1825 55.2698L27.5309 55.6511C27.4969 55.659 27.4638 55.6753 27.4345 55.6986C27.4051 55.722 27.3804 55.7516 27.3626 55.785L27.0295 56.4073L26.3144 56.5723C26.1501 56.6103 25.9949 56.7136 25.8829 56.8595C25.7709 57.0055 25.7113 57.1821 25.7172 57.3506L25.8207 60.3151C25.8266 60.4836 25.8975 60.6301 26.0178 60.7224C26.1381 60.8147 26.298 60.8453 26.4623 60.8074L30.5913 59.8541C30.7555 59.8162 30.9107 59.7129 31.0227 59.5669C31.1347 59.421 31.1943 59.2443 31.1884 59.0759L31.0849 56.1114C31.079 55.9429 31.0081 55.7964 30.8878 55.704C30.7675 55.6117 30.6076 55.5812 30.4434 55.6191ZM30.7755 59.1712C30.7775 59.2273 30.7576 59.2862 30.7203 59.3349C30.683 59.3835 30.6312 59.418 30.5765 59.4306L26.4475 60.3839C26.3927 60.3965 26.3394 60.3863 26.2993 60.3555C26.2592 60.3248 26.2356 60.2759 26.2336 60.2198L26.1301 57.2553C26.1282 57.1991 26.148 57.1402 26.1854 57.0916C26.2227 57.0429 26.2744 57.0085 26.3292 56.9958L27.155 56.8052C27.189 56.7974 27.2221 56.781 27.2516 56.7577C27.281 56.7343 27.3057 56.7046 27.3235 56.6713L27.6561 56.0491L29.0866 55.7189L29.4572 56.1787C29.4771 56.2033 29.5035 56.2212 29.534 56.2307C29.5646 56.2403 29.5984 56.2411 29.6324 56.2332L30.4582 56.0426C30.5129 56.03 30.5662 56.0401 30.6063 56.0709C30.6464 56.1017 30.67 56.1505 30.672 56.2067L30.7755 59.1712ZM28.4085 56.9427C28.1839 56.9946 27.9667 57.1136 27.7845 57.2846C27.6022 57.4557 27.463 57.6712 27.3845 57.9039C27.306 58.1365 27.2917 58.3759 27.3434 58.5917C27.3951 58.8075 27.5105 58.99 27.675 59.1162C27.8395 59.2424 28.0457 59.3067 28.2675 59.3007C28.4893 59.2948 28.7168 59.2191 28.9212 59.083C29.1256 58.947 29.2977 58.7567 29.4158 58.5364C29.5339 58.3161 29.5926 58.0755 29.5846 57.8452C29.5735 57.5365 29.4434 57.2681 29.2229 57.0989C29.0024 56.9298 28.7095 56.8736 28.4085 56.9427ZM28.475 58.8485C28.3321 58.8815 28.1909 58.8703 28.0692 58.8163C27.9475 58.7622 27.8509 58.6679 27.7915 58.5451C27.732 58.4223 27.7125 58.2766 27.7354 58.1264C27.7582 57.9762 27.8225 57.8282 27.9199 57.7013C28.0173 57.5743 28.1436 57.474 28.2828 57.413C28.4219 57.352 28.5677 57.3332 28.7017 57.3588C28.8357 57.3844 28.9519 57.4533 29.0355 57.5569C29.1192 57.6604 29.1666 57.7939 29.1717 57.9405C29.1786 58.1371 29.109 58.3432 28.9784 58.5134C28.8477 58.6837 28.6666 58.8042 28.475 58.8485Z"
          fill="black"
        />
        <path
          d="M87.0579 31.6491L30.543 51.914C30.1347 52.0604 29.8623 52.4475 29.8623 52.8812V53.3158C29.8623 53.8298 30.2422 54.2648 30.7515 54.334L87.2664 62.0126C87.8832 62.0964 88.4323 61.6169 88.4323 60.9944V32.6163C88.4323 31.9052 87.7273 31.409 87.0579 31.6491Z"
          fill="black"
          fillOpacity="0.2"
        />
      </svg>
    </div>
  );
};

export default UploadInstructionStepOne;
